import React from 'react';

function Waiting({visible}) {
  if (!visible) {
    return null;
  }
  return <div className="waiting"/>;
}

Waiting.defaultProps = {
  visible: true
};

Waiting.propTypes = {
  visible: React.PropTypes.bool
};

export default Waiting;



// WEBPACK FOOTER //
// ./src/js/Component/Waiting.jsx